import React from "react";
import { SubsectionWithFields } from "./subsection/fields";
import { SearchCommonField } from "../inputs/common-field";

export const WeatherSection = () => {
    return (
        <>
            <SubsectionWithFields>
                <SearchCommonField name="weather.tmax" />
                <SearchCommonField name="weather.tmin" />
                <SearchCommonField name="weather.sst" />
                <SearchCommonField name="weather.wet" />
                <SearchCommonField name="weather.sunhrs" />
                <SearchCommonField name="weather.dayhrs" />
                <SearchCommonField name="weather.rhm" />
                <SearchCommonField name="weather.ws" />
                <SearchCommonField name="weather.rainseason" />
            </SubsectionWithFields>
        </>
    );
};
